import { useEffect } from 'react';

// When the page is restored from the Back/forward cache, make sure to refresh any stale information.
// See https://web.dev/articles/bfcache#update-data-after-restore
const useOnPageCacheRestore = (handler: () => any) => {
  useEffect(() => {
    const listener = (event: PageTransitionEvent) => {
      if (event.persisted) {
        handler();
      }
    };

    window.addEventListener('pageshow', listener);

    return () => {
      window.removeEventListener('pageshow', listener);
    };
  }, [handler]);
};

export default useOnPageCacheRestore;
